import { render, staticRenderFns } from "./ClassifyRegionsMgmt.vue?vue&type=template&id=0c1d0c96&scoped=true&"
import script from "./ClassifyRegionsMgmt.vue?vue&type=script&lang=js&"
export * from "./ClassifyRegionsMgmt.vue?vue&type=script&lang=js&"
import style0 from "./ClassifyRegionsMgmt.vue?vue&type=style&index=0&id=0c1d0c96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1d0c96",
  null
  
)

export default component.exports